module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-start-selling-headphones-mobile@2x-58dbfeb1c3abff80136de5f1f94954e5.png";